import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { Meta, Title } from '@angular/platform-browser'
import { GtmReportAuthService } from '../../services/gtm-report-auth/gtm-report-auth.service'

@Component({
	selector: 'app-relatorio-gtm-login',
	templateUrl: './relatorio-gtm-login.component.html',
	styleUrls: ['./relatorio-gtm-login.component.scss'],
})
export class RelatorioGtmLoginComponent implements OnInit {
	form: FormGroup
	error = ''
	loading = false
	lang = 'pt'

	constructor(
		private fb: FormBuilder,
		private auth: GtmReportAuthService,
		private router: Router,
		private route: ActivatedRoute,
		private title: Title,
		private meta: Meta
	) {
		this.form = this.fb.group({
			user: [null, Validators.required],
			password: [null, Validators.required],
		})
	}

	ngOnInit(): void {
		this.lang = this.route.snapshot.parent?.params.lang || 'pt'
		this.title.setTitle('Login - Painel de medição')
		this.meta.updateTag(
			{ name: 'robots', content: 'noindex, nofollow' },
			"name='robots'"
		)

		if (this.auth.isLoggedIn()) {
			this.redirectAfterLogin()
		}
	}

	async onSubmit(): Promise<void> {
		this.error = ''
		if (this.form.invalid) {
			this.form.markAllAsTouched()
			return
		}

		const { user, password } = this.form.value
		this.loading = true
		try {
			await this.auth.login(user, password)
			this.redirectAfterLogin()
		} catch (error) {
			this.error = (error as Error).message
		} finally {
			this.loading = false
		}
	}

	private redirectAfterLogin(): void {
		const returnUrl =
			this.route.snapshot.queryParams.returnUrl ||
			`/${this.lang}/relatorio-gtm`
		this.router.navigateByUrl(returnUrl)
	}
}
